/**
 * @module rx-ext
 */
export observableFromOlChangeEvent from './from-ol-change-event'
export observableFromOlEvent from './from-ol-event'
